/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Agent_Wizard_How_Budget_ValueInputs */



/**
* | output |
* | --- |
* | "Up to {count} actions per run" |
*
* @param {Agent_Wizard_How_Budget_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_how_budget_value = /** @type {((inputs: Agent_Wizard_How_Budget_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_How_Budget_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Bis zu ${i?.count} Aktionen pro Lauf`)
	return /** @type {LocalizedString} */ (`Up to ${i?.count} actions per run`)
});